import { Box, IconButton, Paper, Stack, TextField, Typography, Checkbox, FormControlLabel } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";

interface Props {
    block: VideoBlock;
    onChange: (content: any) => void;
    onDelete: () => void;
}

const VideoBlockEditor = ({ block, onChange, onDelete }: Props) => {
    return (
        <Paper sx={{ p: 2, mb: 2 }}>
            <Stack direction="row" spacing={1} alignItems="flex-start">
                <IconButton size="small" sx={{ cursor: "grab" }}>
                    <DragIndicatorIcon />
                </IconButton>
                <Box flex={1}>
                    <Typography variant="subtitle2" sx={{ mb: 1, fontWeight: "bold" }}>
                        Video Block
                    </Typography>
                    <Stack spacing={2}>
                        <TextField
                            label="Video URL (YouTube or Vimeo)"
                            value={block.content.url || ""}
                            onChange={(e) =>
                                onChange({
                                    ...block.content,
                                    url: e.target.value,
                                })
                            }
                            fullWidth
                            size="small"
                            helperText="Enter YouTube or Vimeo video URL"
                        />
                        <TextField
                            label="Caption (optional)"
                            value={block.content.caption || ""}
                            onChange={(e) =>
                                onChange({
                                    ...block.content,
                                    caption: e.target.value,
                                })
                            }
                            fullWidth
                            size="small"
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={block.content.autoplay || false}
                                    onChange={(e) =>
                                        onChange({
                                            ...block.content,
                                            autoplay: e.target.checked,
                                        })
                                    }
                                />
                            }
                            label="Autoplay"
                        />
                    </Stack>
                </Box>
                <IconButton size="small" onClick={onDelete} color="error">
                    <DeleteIcon />
                </IconButton>
            </Stack>
        </Paper>
    );
};

export default VideoBlockEditor;
